module.exports = __webpack_public_path__ + "static/media/example-2.f7434d76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Offer/example-2.jpg
// module id = 399
// module chunks = 0